import { useLocation } from 'react-router-dom';
import { isNewCatalogUser } from '../../utils/utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error Could not find a declaration file for module
import personImageUrlMobile from 'bender-url!../../../images/pngs/Jean_thumbnail.png';
// @ts-expect-error Could not find a declaration file for module
import useMediaQuery from '../../hooks/useMediaQuery';
import { device } from '../../constants/StyledComponentConstants';
import UsageTracker from '../../utils/UsageTracker';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { WIZARD_URL_FRAGMENT } from '../../constants/Navigation';
import { useWizardProgress } from '../../features/wizard/wizardQueries';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { RemoveIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { Flex } from 'foundations-components/components/Flex';
import { BackButton } from 'foundations-components/transitional/components/BackButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { Image } from 'foundations-components/transitional/components/Image';
import I18n from 'I18n';
import { Box } from 'foundations-components/transitional/components/Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WizardActions = ({
  onBackLinkClick,
  onCancelClick,
  totalResultCount,
  catalogUrl
}) => {
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  const location = useLocation();
  const isNewUser = isNewCatalogUser(location.search);
  const trackCatalogLinkClick = () => {
    UsageTracker.track('wizardInteraction', {
      action: 'wizard-click-view-results-on-catalog',
      location: 'results page header'
    });
  };
  const {
    currentStep
  } = useWizardProgress();
  const isFinalStep = currentStep === 'final';
  const showBackButton = location.pathname !== WIZARD_URL_FRAGMENT;
  const showCloseButton = !isNewUser && !isFinalStep;
  const showResultsLink = isFinalStep && totalResultCount > 0;
  return /*#__PURE__*/_jsxs(Flex, {
    flex: isMobile ? '0 0 58px' : '0 0 72px',
    paddingBlockEnd: isMobile ? '0' : '500',
    paddingBlockStart: "500",
    paddingInline: isMobile ? '200' : '1000',
    children: [/*#__PURE__*/_jsxs(Box, {
      grow: 1,
      children: [showBackButton && /*#__PURE__*/_jsx(BackButton, {
        children: /*#__PURE__*/_jsx(Button, {
          onClick: onBackLinkClick,
          use: "link",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.wizard.modal.buttons.backlink"
          })
        })
      }), isMobile && !showBackButton && /*#__PURE__*/_jsx(Image, {
        marginBlockEnd: "-200",
        src: personImageUrlMobile,
        width: 44
      })]
    }), showCloseButton && /*#__PURE__*/_jsx(IconButton, {
      "aria-label": I18n.text('learningCenter.common.close'),
      onClick: onCancelClick,
      paddingBlock: "100",
      use: "transparent",
      children: /*#__PURE__*/_jsx(RemoveIcon, {
        color: "icon-core-subtle",
        size: "600"
      })
    }), showResultsLink && /*#__PURE__*/_jsx(UIRouterLink, {
      onClick: trackCatalogLinkClick,
      to: catalogUrl,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.wizard.modal.stepfinal.resultslink",
        options: {
          resultsCount: totalResultCount
        }
      })
    })]
  });
};
export default WizardActions;